import { g as o } from "./_commonjsHelpers-OnjxAlhP.js";
const i = !!o().window;
export {
  i
};
